module.exports = __webpack_public_path__ + "static/media/co2Footprint.5f8e15d8.png";